/** Canaux de billetterie payante externe : un billet qui en provient n'est jamais "gratuit", même à 0€. */
const PAID_CANALS = ['DICE', 'SHOTGUN'];
/** Canaux dont les billets sont gratuits par nature. */
const FREE_CANALS = ['On Site', 'Invited'];

/**
 * Billet réellement gratuit (= changement de tarif autorisé).
 * null/undefined ne comptent PAS comme gratuit (fail-safe : pricettc absent en BDD = bug, on n'autorise pas le changement).
 * Source de vérité partagée entre le drawer et la liste parente — garder les deux alignés.
 */
export function isFreeTicket(
  p: { pricettc?: number | null; status?: string; canal?: string } | null | undefined,
): boolean {
  if (!p) return false;
  const canal = p.canal;
  // Garde : un canal payant prime, même si le prix est à 0.
  if (canal && PAID_CANALS.includes(canal)) return false;
  const price = p.pricettc;
  return (price != null && Number(price) === 0)
    || p.status === 'Imported'
    || (canal != null && FREE_CANALS.includes(canal));
}

export interface ParticipantDetail {
  id: string;
  accountNumber?: string;
  lastName: string;
  firstName: string;
  email: string;
  barcode: string;
  shortTag?: string;
  status?: string;
  canal?: string;
  associatedNfc?: string;
  tplName: string;
  tplOriginalName?: string;
  tplId: string;
  idEvent: string;
  pricettc: number;
  pdfUrl?: string;
  totScan: number;
  maxScan: number;
  flag: boolean;
  ban: boolean;
  formAnswers?: string;
  history: ParticipantHistoryEntry[];
}

export interface ParticipantHistoryEntry {
  type: 'in' | 'out' | 'mark' | 'block';
  title: string;
  who: string;
  when: string;
  device: string;
}

export interface TplOption {
  _id: string;
  name: string;
}

export interface TplChangeEvent {
  participantId: string;
  newTplId: string;
  newTplName: string;
}

export interface NfcAssociateEvent {
  participantId: string;
  tag: string;
}

export interface ParticipantApiDTO {
  _id: string;
  firstNameUser: string;
  lastNameUser: string;
  email?: string;
  status?: string;
  canal?: string;
  keyRandom: string;
  shortTag?: string;
  associatedNfc?: string;
  idTplTicket: string;
  nameTpl?: string;
  nameTplOriginal?: string;
  idEvent: string;
  pricettc?: number;
  urlTicket?: string;
  totScan: number;
  maxscan: number;
  flag?: string;
  ban?: string;
  formAnswers?: string;
  tabScanIn?: { date: string; idStaff: string }[];
  tabScanOut?: { date: string; idStaff: string }[];
  scans?: Record<string, number>;
}

export interface ParticipantApiResponse {
  participant: ParticipantApiDTO;
}
